import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  SessionSummaryActionPayload,
  GetSessionSummaryResponse,
  CreditAppliedActionPayload,
  UpdateTransactionStatusActionPayload,
  UpdateTransactionStatusResponseV1,
  UpdatedSessionDocuments,
  UpdateSelectedDocumentInfoActionPayload,
  UpdateSelectedDocumentInfoActionSuccessPayload,
  ModifiedDocumentMeta,
  UpdatePaymentV1Request,
  SessionPayment,
  SessionPaymentTransaction,
  PaymentProcess,
  AppliedDiscountMeta,
  PayOtherAmountV1Response,
} from '@arc/unified-payments-frontend/shared-payment';

export const GetSessionSummaryAction = createAction(
  '[BtPay Session] Get Session Summary Action',
  props<{
    payload: SessionSummaryActionPayload;
  }>(),
);

export const GetSessionSummarySuccessAction = createAction(
  '[BtPay Session] Get Session Summary Success Action',
  props<{
    payload: GetSessionSummaryResponse;
  }>(),
);

export const GetSessionSummaryErrorAction = createAction(
  '[BtPay Session] Get Session Summary Error Action',
  props<{
    payload: HttpErrorResponse;
  }>(),
);

export const UpdateSelectedDocumentsComplete = createAction(
  '[BtPay Session] Update Selected Documents Complete',
  props<{
    payload: UpdatedSessionDocuments;
  }>(),
);

export const CalculateZeroDollarPayment = createAction(
  '[BtPay Session] Calculate Zero Dollar Payment',
);

// deprecated in favor of component actions
export const IntlZeroDollarPaymentCalculated = createAction(
  '[BtPay Session - Intl] Zero Dollar Payment Calculated',
  props<{
    payload: CreditAppliedActionPayload;
  }>(),
);

export const PayableAmountEditedErrorAction = createAction(
  '[BtPay Session] Payable Amount Edited Error',
);

export const PayableAmountEditedShortPaymentErrorAction = createAction(
  '[BtPay Session] Payable Amount Edited Short Payment Error',
);

export const PayableAmountEditedOverPaymentErrorAction = createAction(
  '[BtPay Session] Payable Amount Edited Over Payment Error',
);

export const PayableAmountEditedCreditUsedForOverPaymentErrorAction =
  createAction(
    '[BtPay Session] Payable Amount Edited Credit Used For Over Payment Error',
  );

export const validateCreditMemoPayableAmountEdit = createAction(
  '[BtPay Session] Validate Credit Memo Payable Amount Edit',
  props<{
    payload: UpdateSelectedDocumentInfoActionPayload;
  }>(),
);

export const ValidateInvoicePayableAmountEditAction = createAction(
  '[BtPay Session] Validate Invoice Payable Amount Edit',
  props<{
    payload: UpdateSelectedDocumentInfoActionPayload;
  }>(),
);

export const UpdateSelectedSessionDocumentsAction = createAction(
  '[BtPay Session] Update Selected Session Documents Action',
  props<{
    payload: UpdateSelectedDocumentInfoActionPayload;
  }>(),
);

export const UpdateSelectedSessionDocumentsActionSuccess = createAction(
  '[BtPay Session] Update Selected Session Documents Action Success',
  props<{
    payload: UpdateSelectedDocumentInfoActionSuccessPayload;
  }>(),
);

// deprecated in favor of component actions
export const IntlUpdateAppliedDiscountAmountAction = createAction(
  '[BtPay Session - Intl] Update Applied Discount Amount Action',
  props<{
    payload: AppliedDiscountMeta[];
  }>(),
);

export const UpdatePaymentAction = createAction(
  '[BtPay Session] Update Payment',
  props<{
    request: UpdatePaymentV1Request;
  }>(),
);

export const UpdatePaymentSuccessAction = createAction(
  '[BtPay Session] Update Payment Success',
  props<{
    response: SessionPayment;
    paymentProcess: PaymentProcess;
  }>(),
);

export const UpdatePaymentErrorAction = createAction(
  '[BtPay Session] Update Payment Error',
  props<{
    error: HttpErrorResponse;
  }>(),
);

export const UpdatePayOtherPayablesAction = createAction(
  '[BtPay Session] Update Pay Other Payables Action',
  props<{
    payload: PayOtherAmountV1Response;
  }>(),
);

export const UpdatePayOtherPayblesErrorAction = createAction(
  '[BtPay Session] Update Transaction Status Error',
  props<{
    error: HttpErrorResponse;
  }>(),
);

export const UpdateTransactionStatus = createAction(
  '[BtPay Session] Update Transaction Status',
  props<{
    payload: UpdateTransactionStatusActionPayload;
  }>(),
);

export const UpdateTransactionStatusSuccess = createAction(
  '[BtPay Session] Update Transaction Status Success',
  props<{
    response: UpdateTransactionStatusResponseV1;
  }>(),
);

export const UpdateTransactionStatusError = createAction(
  '[BtPay Session] Update Transaction Status Error',
  props<{
    error: HttpErrorResponse;
  }>(),
);

export const UpdateModifiedDocumentsUrnListAction = createAction(
  '[BtPay Session] Update Modified Documents Urn List',
  props<{
    payload: ModifiedDocumentMeta;
  }>(),
);

export const UpdateSessionPaymentTransactionStatusAction = createAction(
  '[BtPay Session] Update Session Payment Transaction Status',
  props<{
    payload: SessionPaymentTransaction[];
  }>(),
);

export const UpdateSessionPaymentGivenDiscountAction = createAction(
  '[BtPay Session] Update Session Payment Given Discount',
);

export const SetPaymentProcessAction = createAction(
  '[BtPay Session] Set Payment Process',
  props<{ paymentProcess: PaymentProcess }>(),
);

export const ExecuteNegativePaymentAction = createAction(
  '[BtPay] Execute Negative PaymentAction',
);

export const UpdateRUMPaymentTagsAction = createAction(
  '[Btpay Session] Update RUM Payment Tags Action',
  props<{ payload: SessionPayment }>(),
);

export const UpdateRUMSessionTagsAction = createAction(
  '[BtPay Session] Update RUM Session Tags Action',
  props<{ payload: GetSessionSummaryResponse }>(),
);

export const applySoftBlockDocumentDeselection = createAction(
  '[BtPay Session - Intl] Apply Soft Block Document Deselection',
);
